import RouterUtil from "@/utils/RouterUtil";
export default {
  name: "NavBar",
  props: {
    title: {
      type: String,
      require: true
    },
    border: {
      type: Boolean,
      require: false,
      default: true
    },
    showLeftIcon: {
      type: Boolean,
      require: false,
      default: true
    },
    showHomeIcon: {
      type: Boolean,
      require: false,
      default: false
    },
    rightIcon: {
      type: String,
      require: false,
      default: null
    },
    rightClick: {
      type: Function,
      require: false,
      default: null
    }
  },
  data() {
    return {
      gotoMode: false
    };
  },
  mounted() {
    if (this.$route.query && this.$route.query.ref === "goto") {
      this.gotoMode = true;
    }
  },
  methods: {
    goBack() {
      RouterUtil.back();
    },
    goHome() {
      RouterUtil.home();
    }
  }
};